const MyIcon = ({ Icon, label, marginBottom = '8px', marginLeft = '0px' }) => {
  return (
    <div style={{ color: 'white', height: '30px', display: 'flex', alignItems: 'center', marginBottom: marginBottom, marginLeft: marginLeft }}>
      <Icon style={{ height: '30px' }} />
      <span style={{ marginLeft: '10px', fontWeight: 600 }}>{label}</span>
    </div>
  );
};

export default MyIcon;
